import _chunk from 'lodash/chunk';
import classnames from 'classnames';
import USER_EXAM_STATUS from '@achievable-me/tundra-wizard/userExamStatus';
import USER_EXAM_ITEM_STATUS from '@achievable-me/tundra-wizard/userExamItemStatus';
import React, { Component } from 'react';

import styles from './styles.scss';

const CHUNK_SIZE = 8;

const getQuestionClasses = ({ quizObj, userExam }) => {
  const { isFlagged } = quizObj.item;
  const isFinished = userExam.status === USER_EXAM_STATUS.finished;
  const isCorrect = quizObj.item.status === USER_EXAM_ITEM_STATUS.correct;
  const isIncorrect = quizObj.item.status === USER_EXAM_ITEM_STATUS.incorrect;
  const isUnanswered = !quizObj.item.status;

  return classnames([
    styles.question,
    !isFinished && isUnanswered && classnames('aaaUnanswered', styles.unanswered),
    isFlagged && classnames('aaaFlagged', styles.flagged),
    isFinished && isCorrect && classnames('aaaCorrect', styles.correct),
    isFinished && isIncorrect && classnames('aaaIncorrect', styles.incorrect),
  ]);
};

class ExamNavigation extends Component {
  renderQuestions() {
    const { handleQueueNavigation, quizState } = this.props;
    const { quizQueue, userExam } = quizState;

    return (
      <div>
        Select a question to jump to it.
        <br />
        <br />
        <div className={styles.questionsContainer}>
          {_chunk(quizQueue, CHUNK_SIZE).map((quizObjsChunk, i) => {
            return (
              <div key={i} className={styles.questionsRow}>
                {quizObjsChunk.map((quizObj, j) => {
                  const queueIndex = i * CHUNK_SIZE + j;
                  const itemNum = queueIndex + 1;
                  const questionClasses = getQuestionClasses({ quizObj, userExam });
                  return (
                    <div
                      data-aaa={`jump-${queueIndex}`}
                      key={quizObj.item.uuid}
                      className={questionClasses}
                      onClick={() => handleQueueNavigation({ queueIndex })}
                    >
                      {itemNum}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.layout}>
        <div className={styles.layoutInner}>{this.renderQuestions()}</div>
      </div>
    );
  }
}

export default ExamNavigation;
